import { ColumnDef, Row, Table } from '@tanstack/react-table';

import { Checkbox } from '../../checkbox/checkbox';

export const onRowSelectionChange =
  <T,>(row: Row<T>, onRowSelect?: (rows: T[]) => void, onRowDeselect?: (rows: T[]) => void) =>
  (event: React.ChangeEvent<HTMLInputElement>) => {
    const previousSelection = row.getIsSelected();
    if (row.getIsGrouped()) {
      for (const subRow of row.subRows) subRow.toggleSelected(!row.getIsAllSubRowsSelected());
    } else {
      row.getToggleSelectedHandler()(event);
    }
    if (previousSelection) {
      onRowDeselect?.([row.original]);
    } else {
      onRowSelect?.([row.original]);
    }
  };

export const onAllRowsSelectionChange =
  <T,>(table: Table<T>, onRowSelect?: (rows: T[]) => void, onRowDeselect?: (rows: T[]) => void) =>
  (event: React.ChangeEvent<HTMLInputElement>) => {
    const previousSelection = table.getIsAllRowsSelected();
    const prevSelectedKeys = table.getState().rowSelection;
    const { grouping } = table.getState();
    const isGrouped = grouping.length > 0;
    let selectedRows: Row<T>[] = [];

    if (isGrouped) {
      const rows = table.getRowModel().rows;
      for (const row of rows) {
        row.toggleSelected(event.target.checked);
        selectedRows = [...selectedRows, ...row.getLeafRows()];
      }
    } else {
      table.getToggleAllRowsSelectedHandler()(event);
      selectedRows = table.getPreSelectedRowModel().rows;
    }

    if (previousSelection) {
      onRowDeselect?.(selectedRows.filter((row) => prevSelectedKeys[row.id]).map((row) => row.original));
    } else {
      onRowSelect?.(selectedRows.filter((row) => !prevSelectedKeys[row.id]).map((row) => row.original));
    }
  };

export const selectColumnConfig = <T,>(
  onRowSelect?: (rows: T[]) => void,
  onRowDeselect?: (rows: T[]) => void,
  isLoading = false
): ColumnDef<T> => ({
  id: 'select',
  enableHiding: false,
  enableSorting: false,
  size: 62,
  header: ({ table }) => (
    <div className={`flex items-center ${isLoading && 'collapse'}`}>
      <Checkbox
        isChecked={table.getIsAllPageRowsSelected()}
        isPartiallyChecked={table.getIsSomePageRowsSelected()}
        onChange={onAllRowsSelectionChange(table, onRowSelect, onRowDeselect)}
        hideLabel
        isDisabled={isLoading}
        label={''}
        value={`table_selection`}
      />
    </div>
  ),
  cell: ({ row }) => {
    return (
      <div className={`flex items-center ${isLoading && 'collapse'}`}>
        <Checkbox
          isChecked={row.getIsGrouped() ? row.getIsAllSubRowsSelected() : row.getIsSelected()}
          isDisabled={!row.getCanSelect()}
          isPartiallyChecked={row.getIsSomeSelected()}
          onChange={onRowSelectionChange(row, onRowSelect, onRowDeselect)}
          hideLabel
          label={''}
          value={`row_${row.id}_selection`}
        />
      </div>
    );
  },
});
